/**
 * Created by aaikepae on 1/28/17.
 */
import React from "react"
import {generateConfigData, generateInfoCard} from "Common/utility/infoCard"


export default class SandboxInfoCard extends React.Component {


  render() {
    const {config, location} = this.props;

    if (!config) {
      return <span>Loading</span>
    }


    const data = generateConfigData(config);
    const elements = generateInfoCard(data, location, this.props.type);
    /*
     widget root
     you can add background image or background color
     */
    /*
     all root widget should start from `.conatiner` class
     */
    /* grid layout
     https://v4-alpha.getbootstrap.com/layout/grid/
     */
    return (
      <div className="pubhub-sandbox-info-card pubhub-widget">
        <div className="container">

          <div className="row">
            <div className=" col-sm-12 col-md-4 pubhub-sandbox-info-card-img">
              <span data-track-name="sandboxInfocard:image"
                    data-track-value={data.title} >
                {elements.image}
              </span>

            </div>
            <div className="col-sm-12 col-md-8 pubhub-sandbox-info-card-detail">
              {elements.subtitle}
              <div data-track-name="sandboxInfocard:title"
                   data-track-value={data.title} >
                {elements.title}
              </div>

              {elements.description}
              <span data-track-name="sandboxInfocard:tryitout"
                    data-track-value={data.title} >
                {elements.link}
              </span>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
